/* GENERATED by scripts/gen-data.mjs — chapter "x-softmax" (from s2.js + s3.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

import type { NodeDef } from '../../types';

export const N_X_SOFTMAX: NodeDef = {
  "id": "x-softmax",
  "tagKey": "path:x-softmax.tag",
  "x": 376,
  "y": 180,
  "w": 176,
  "h": 88,
  "titleKey": "path:x-softmax.title",
  "subKey": "path:x-softmax.sub",
  "blocks": [
    {
      "id": "x-softmax.b1",
      "kind": "explain",
      "xp": 15,
      "titleKey": "path:x-softmax.b1.title",
      "bodyKey": "path:x-softmax.b1.body",
      "flowKey": "path:x-softmax.b1.flow"
    },
    {
      "id": "x-softmax.b2",
      "kind": "film",
      "xp": 25,
      "titleKey": "path:x-softmax.b2.title",
      "film": "f-softmax"
    },
    {
      "id": "x-softmax.b3",
      "kind": "check",
      "xp": 30,
      "titleKey": "path:x-softmax.b3.title",
      "ex": {
        "type": "choice",
        "options": [
          {
            "tKey": "path:x-softmax.b3.ex.options.0.t",
            "ok": true,
            "fbKey": "path:x-softmax.b3.ex.options.0.fb"
          },
          {
            "tKey": "path:x-softmax.b3.ex.options.1.t",
            "ok": false,
            "fbKey": "path:x-softmax.b3.ex.options.1.fb"
          },
          {
            "tKey": "path:x-softmax.b3.ex.options.2.t",
            "ok": false,
            "fbKey": "path:x-softmax.b3.ex.options.2.fb"
          }
        ]
      }
    }
  ],
  "extra": true,
  "parent": "model-families"
};
